/**
 * OTC Shared Types - DealBookingType, ProductSelectorType, OTCFieldsData and related form/UI types
 * Used across DealProductBuilder, ManualDealTradeView, OTCFieldsDialog, etc.
 */

export type DealBookingType = 'forward' | 'fixedRateLoan' | 'option' | 'floatingRateLoan' | 'repo';

/**
 * Coarse OTC vs Loan bucket for header toggles (Manual Deal, Deal Product Builder) and URL segments.
 * Subtype remains {@link DealBookingType} (forward/option vs fixed/floating loan).
 * 'repo' is a top-level type with no sub-toggle.
 */
export type ProductSelectorType = 'otc' | 'loan' | 'repo';

export const RepoDirectionEnum = {
  Repo: 'Repo',
  ReverseRepo: 'ReverseRepo',
} as const;
export type RepoDirectionEnum = (typeof RepoDirectionEnum)[keyof typeof RepoDirectionEnum];
